import { defineComponent as _defineComponent } from 'vue'
import store from "@/store";
  import { computed, ref, onMounted, watch } from "vue";
  import CustomizeHouseSlider from "@/components/builder/CustomizeHouseSlider.vue";
  import { HouseDesignInterface } from "@/types/HouseDesignInterface";
  import BuilderSliderButtons from "./BuilderSliderButtons.vue";
  import { useIsDesktop } from "@/features/useIsDesktop";
  import { CustomizeHouseStepsEnum } from "@/enums/CustomizeHouseSteps";
  import BuilderSliderImages from "./BuilderSliderImages.vue";
  import { FacadeInterface } from "@/types/FacadeInterface";

  interface Props {
    selectedHouseDesign: HouseDesignInterface;
  }
  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderSelectionFacades',
  props: {
    selectedHouseDesign: {}
  },
  emits: [
    "onRequestQuotes",
    "onButtonStepVisiblyConfirmation",
    "onButtonStepVisiblyConfirmationOff",
  ],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const props = __props;

  const { isDesktop } = useIsDesktop(990);

  const isFacadeSelected = ref(false);
  const sliderImages = ref<string[]>([]);
  const facadesFormatted = ref<{ id: string; _id: string; name: string }[]>([]);

  const house = computed(() => props.selectedHouseDesign);

  const selectedFormattedFacade = computed(() => {
    const facade = selectedQuote.value.facade;

    return {
      id: facade.id,
      _id: facade.url,
      name: facade.name,
    };
  });

  const selectedQuote = computed(() => {
    return store.getters["builder/getSelectedSelection"];
  });
  const setSliderImages = () => {
    const facadeUrl = selectedQuote.value?.facade?.url;
    const houseFacades = house.value.facades.map((item) => item.url);

    sliderImages.value = facadeUrl ? [facadeUrl] : houseFacades;
  };
  const updateUserSelectionState = (facade: FacadeInterface) => {
    store.commit("builder/updateUserSelection", {
      ...selectedQuote.value,
      facade,
    });
  };
  const onGetQuote = () => {
    emits("onRequestQuotes");
  };

  watch(
    props.selectedHouseDesign,
    () => {
      setSliderImages();
    },
    { deep: true }
  );
  const onSelectFacade = (facade: FacadeInterface) => {
    updateUserSelectionState(facade);
    setSliderImages();

    if (!isFacadeSelected.value) {
      isFacadeSelected.value = true;
    }

    emits("onButtonStepVisiblyConfirmation", true);
  };

  onMounted(() => {
    setSliderImages();
    isFacadeSelected.value = false;
    facadesFormatted.value = house.value.facades.map((item) => ({
      ...item,
      id: item._id,
      _id: item.url,
      name: item.name,
    }));
    emits("onButtonStepVisiblyConfirmationOff", true);
  });

  watch(
    props,
    () => {
      setSliderImages();
    },
    { deep: true, immediate: true }
  );

const __returned__ = { emits, props, isDesktop, isFacadeSelected, sliderImages, facadesFormatted, house, selectedFormattedFacade, selectedQuote, setSliderImages, updateUserSelectionState, onGetQuote, onSelectFacade, get store() { return store }, computed, ref, onMounted, watch, CustomizeHouseSlider, get HouseDesignInterface() { return HouseDesignInterface }, BuilderSliderButtons, get useIsDesktop() { return useIsDesktop }, get CustomizeHouseStepsEnum() { return CustomizeHouseStepsEnum }, BuilderSliderImages, get FacadeInterface() { return FacadeInterface } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})